var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-alert d-flex"},[_c('div',{class:_vm.leftSideClasses}),_c('div',{class:_vm.rightSideClasses,attrs:{"role":"alert"}},[_vm._t("default",function(){return [_vm._v("tekst")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }